import React, { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const AuthRoute = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  
  useEffect(() => {
    if (!user) {
      localStorage.removeItem('coupons'); // Clear stale data
    }
  }, [user]);

  return user ? <Outlet /> : <Navigate to="/login" replace />;
};

export default AuthRoute;